import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../../constants/axiosInstance';

interface AddDataLoggerResponse {
  status: boolean;
  data: {
  id: string;
  message: string;
  serialNumber: string;
  }
}

interface AddDataLoggerPayload {
  code: string;
}

const addDataLogger = async (data: AddDataLoggerPayload): Promise<AddDataLoggerResponse> => {
  const response = await axiosInstance().post<AddDataLoggerResponse>('/data-logger/verifyDataLogger', data);
  return response.data;
};

export function useAddDataLogger() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const mutation = useMutation<AddDataLoggerResponse, Error, AddDataLoggerPayload>({
    mutationFn: addDataLogger,
    onSuccess: (data) => {
      toast.success(t('dataLogger.addSuccess', 'Data logger added successfully'));
      queryClient.invalidateQueries({ queryKey: ['dataLoggers'] });
      return data?.data;
    },
  });

  return {
    handleSubmit: mutation.mutate,
    isPending: mutation.isPending,
    error: mutation.error,
    data: mutation.data,
  };
} 